import React from "react";
import DOMPurify from 'dompurify';

const PaymentList = ({htmlValue}) => {
    
return (
    <div className="listUlResponsive"
        dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
                htmlValue,
                {USE_PROFILES: {html: true}}
            ),
        }}
    ></div>
    );
};

export default PaymentList;
